import { KEYS, readOneOf, writeString } from "@khazzin/i18n/storage";

/**
 * The Driver App's theme (EP10-S21, DA-10-23): this phone's choice, like its
 * language — no server round trip. `light` is the outdoor theme, the one
 * readable in the sun; `system` is the absence of `data-theme`, which
 * `index.css` resolves from the OS (see apps/admin/src/app/theme.tsx).
 */

export const THEMES = ["light", "dark", "system"] as const;
export type Theme = (typeof THEMES)[number];

export function storedTheme(): Theme {
	return readOneOf(KEYS.theme, THEMES, "system");
}

/** Paints and remembers a theme. Safe before React renders. */
export function applyTheme(theme: Theme, remember = false): void {
	if (theme === "system") {
		document.documentElement.removeAttribute("data-theme");
	} else {
		document.documentElement.setAttribute("data-theme", theme);
	}
	if (remember) {
		writeString(KEYS.theme, theme);
	}
}
